import React from "react";
import { Modal } from "../widgets";
import "../../../assets/scss/print-load.scss";
import LoadPrint from "./LoadPrint";

const LoadPreview = (props) => {
  const { show, onHide, load } = props;

  return (
    <Modal show={show} onHide={onHide} className="preview-load" size="xl">
      <Modal.Header closeButton className="preview-header">
        Load Preview
      </Modal.Header>
      <LoadPrint load={load} />
    </Modal>
  );
};

export default LoadPreview;